import Vue from 'vue'
import dataMethod from './data-method'
import appBase from './module/app.base'
import appFacebook from './module/app.facebook'
import appDateTimePickers from './module/app.datetimepickers'
import appDataTable from './module/app.data-table'
import appBanner from './module/app.banner.js'
import './vendor/custom'
import Users from './component/User/Users.vue'
import UserLogin from './component/User/UserLogin.vue'
import BookingCreate from './component/Booking/BookingCreate.vue'
import BookingEdit from './component/Booking/BookingEdit.vue'
import LoaderBox from './component/Loader/LoaderBox.vue'
import LoaderCircle from './component/Loader/LoaderCircle.vue'
import SmsCompose from './component/Sms/SmsCompose.vue'
import SmsFromFile from './component/Sms/SmsFromFile.vue'
import LoaderLosange from './component/Loader/LoaderLosange.vue'
import PromoGenerate from './component/PromoGenerate.vue'
import MenuCreate from './component/Menu/MenuCreate.vue'
import MenuEdit from './component/Menu/MenuEdit.vue'
import RestaurantCreate from './component/Restaurant/RestaurantCreate.vue'
import OrderCreate from './component/Order/OrderCreate.vue'
import PostCreate from './component/Post/PostCreate.vue'
import PostEdit from './component/Post/PostEdit.vue'
import Test from './component/Test.vue'
import banner from "./module/app.banner";
import debounce from "lodash.debounce";
import mixins from './mixins'
import appAxios from './app-axios'
window.appAxios = appAxios

document.addEventListener('DOMContentLoaded', () => {
  let $appContainer = document.querySelector('#app-container')
  if ($appContainer) {
    window.Vue = Vue
    Vue.mixin(mixins)
    const app = new Vue({
      el: '#app-container',
      components: {
        UserLogin,
        BookingCreate,
        BookingEdit,
        Users,
        LoaderCircle,
        LoaderLosange,
        LoaderBox,
        SmsCompose,
        SmsFromFile,
        PromoGenerate,
        RestaurantCreate,
        MenuCreate,
        MenuEdit,
        OrderCreate,
        PostCreate,
        PostEdit,
        Test
      }
    })
  }
  dataMethod()


  appBase()
  appDataTable()
  appDateTimePickers(document)
  appFacebook()
  let scene = appBanner()
  if (scene) {
    window.addEventListener('resize', debounce(_ => {
      scene.removeLayer(scene.layer())
      console.log('debounced')
      scene = banner()
    }, 400))
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/kf.assets.js